import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';
import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import {Edit, RequestPage} from '@vedmarket/ui-kit';

import {COLORS} from '../../../../../../../config/constants';
import {getPluralForm} from '../../../../../../../utils/validation';
import {numberWithSpaces} from '../../../../../../../utils/helpers';

import './customsTitle.scss';

const CustomsTitle = ({declaration, index}: CustomsTitleProps) => {
  const { t } = useTranslation();

  const codesDeclensions: PluralForms = [
    t('declension__text__HSCodeOne'),
    t('declension__text__HSCodeSeveral'),
    t('declension__text__HSCodeMany'),
  ];
  const productsDeclensions: PluralForms = [
    t('declension__text__itemOne'),
    t('declension__text__itemSeveral'),
    t('declension__text__itemMany'),
  ];

  const codeCount = declaration.code_count || 0;
  const productCount = declaration.product_count || 0;
  const codeCaption = `${codeCount} ${getPluralForm(codeCount, codesDeclensions)}`;
  const productCaption = `${productCount} ${getPluralForm(productCount, productsDeclensions)}`;

  return (
    <div className='customs-title'>
      <div className='customs-title__left'>
        {declaration.is_completed
          ? <RequestPage color={COLORS.GREEN} className='customs-title__icon'/>
          : <Edit color={COLORS.LIGHT_TEXT_DISABLED_OPACITY} className='customs-title__icon'/>}
        <div className='customs-title__information'>
          <Typography variant='h6' sx={{
            color: COLORS.BLACK_DARK,
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '26px',
            letterSpacing: 0,
          }}>
            {formatDemoCopy(`${t('calc__text__customs__declaration')} №${index + 1}`)}
          </Typography>
          <Typography variant='body2' sx={{
            color: COLORS.LIGHT_TEXT_DISABLED,
            lineHeight: '21px',
            letterSpacing: 0,
          }}>
            {formatDemoCopy(`${codeCaption}, ${productCaption}`)}
          </Typography>
        </div>
      </div>
      <div className='customs-title__right'>
        <Typography variant='h6' sx={{
          color: COLORS.BLACK_DARK,
          fontSize: '20px',
          fontWeight: 400,
          lineHeight: '26px',
          letterSpacing: 0,
        }}>
          {`${numberWithSpaces(declaration.fees_total || 0)} USD`}
        </Typography>
        <Typography variant='body2' sx={{
          color: COLORS.LIGHT_TEXT_DISABLED,
          lineHeight: '21px',
          letterSpacing: 0,
        }}>
          {formatDemoCopy(t('common__text__customsPayment'))}
        </Typography>
      </div>
    </div>
  );
};

export default CustomsTitle;
